import {
  FamilyMember,
  FamilyMemberState,
  FetchState,
} from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import { listFamilyMembers } from "@/shared/api/userService";
import _ from "lodash";
import { defineStore } from "pinia";

const initialState: FamilyMemberState = {
  fetchState: FetchState.Uninitialized,
  family: {},
  username: ""
};

export const useFamilyStore = defineStore("family", {
  state: (): FamilyMemberState => (_.cloneDeep(initialState)),
  getters: {
    familyMembers: state => (state.fetchState === FetchState.Loaded)
      ? Object.keys(state.family).map(key => state.family[key])
      : null,
    isLoading: state => state.fetchState === FetchState.Loading,
    isLoaded: state => state.fetchState === FetchState.Loaded,
    isFailed: state => state.fetchState === FetchState.Failed
  },
  actions: {
    setFamilyMembers (familyMembers: FamilyMember[]) {
      this.family = familyMembers.reduce((result, current) => {
        result[current.id] = current;
        return result;
      }, {});
    },
    initialize (args: { username: string, partnerId: number }) {
      if (this.username === args.username) {
        return;
      }

      this.family = {};
      this.fetchState = FetchState.Loading;

      listFamilyMembers(args)
        .then(response => {
          this.setFamilyMembers(response.data);
          this.username = args.username;
          this.fetchState = FetchState.Loaded;
        })
        .catch(error => {
          this.family = {};
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    },
  }
});
